<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Agendamento de consulta"
    >
        <List
            @create="create"
            is-modal
        />

        <Modal
            :paciente-id="id"
            @save="handleSave"
            close-on-save
            ref="Modal"
            v-if="id"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/agendamento/List'
import Modal from '@/components/ambulatorio/agendamento/components/cadastro/Modal'

export default {
    components: {
        List,
        Modal,
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        create(id) {
            this.id = id
            this.$nextTick().then(() => this.$refs.Modal.create())
        },
        handleSave() {
            this.id = null
            this.$refs.RkmModal.hide()
        },
    },
}
</script>